import React, { Fragment } from "react";
import imageJcBaey from "./images/jcbaey.jpg";
import imageBJamin from "./images/bjamin.jpg";
import { Image } from "semantic-ui-react";

const authors = {
  jcbaey: {
    image: imageJcBaey,
    text: "Jean-Christophe Baey",
  },
  bjamin: {
    image: imageBJamin,
    text: "Benoist Jamin",
  },  
};

export const Author = {
  Image: ({ id }) => <Image circular src={authors[id].image} />,
  Text: ({ id }) => <Fragment>{authors[id].text}</Fragment>,
};
